import Loader from 'common/components/loaders/Loader'

import { EmlSelection } from './EmlImportTabContent'
import { ImageSelection } from './ImageImportTabContent'
import { PdfSelection } from './PdfImportTabContent'

type Props = {
  html: string
  pdfSelection: PdfSelection | null
  imageSelection: ImageSelection | null
  emlSelection: EmlSelection | null
}

const ReferencePreview = ({
  html,
  pdfSelection,
  imageSelection,
  emlSelection,
}: Props) => {
  if (
    pdfSelection?.isProcessing ||
    imageSelection?.isProcessing ||
    emlSelection?.isProcessing
  ) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gold-300/25 rounded-sm">
        <Loader size="small" />
      </div>
    )
  }

  if (pdfSelection?.thumbnailUrl) {
    return (
      <div className="flex-1 min-h-0 w-full flex items-center justify-center">
        <img
          src={pdfSelection.thumbnailUrl}
          alt="PDF preview"
          className="h-full w-full object-contain rounded-md border-2 border-gold-400 shadow-md bg-white p-2"
          data-testid="pdf-thumbnail"
        />
      </div>
    )
  }

  if (pdfSelection?.extractedText) {
    return (
      <div className="flex-1 flex items-center justify-center text-lg text-base-700 text-center bg-gold-300/25 rounded-sm">
        PDF ready to add.
      </div>
    )
  }

  if (imageSelection?.previewUrl) {
    return (
      <div className="flex-1 min-h-0 w-full flex items-center justify-center">
        <img
          src={imageSelection.previewUrl}
          alt="Image preview"
          className="h-full w-full object-contain rounded-md border-2 border-gold-400 shadow-md bg-white p-2"
          data-testid="image-thumbnail"
        />
      </div>
    )
  }

  if (emlSelection?.html) {
    return (
      <div className="flex-1 min-h-0 w-full flex flex-col gap-2">
        {emlSelection.subject && (
          <p
            className="text-sm text-base-700 shrink-0"
            data-testid="eml-subject"
          >
            <span className="font-medium">Subject:</span> {emlSelection.subject}
          </p>
        )}
        <div className="flex-1 min-h-0 grid">
          <iframe
            srcDoc={emlSelection.html}
            className="h-full w-full rounded-md border-2 border-gold-400 shadow-md bg-white"
            sandbox=""
            title="Email preview"
            data-testid="eml-preview"
          />
        </div>
      </div>
    )
  }

  if (html.trim()) {
    return (
      <iframe
        srcDoc={html}
        className="w-full flex-1 min-h-0 border border-gold-400 rounded-sm"
        sandbox=""
        title="Pasted HTML preview"
      />
    )
  }

  return (
    <div className="flex-1 flex items-center justify-center text-lg text-base-700 text-center bg-gold-300/25 rounded-sm">
      Add a file or paste content to see a preview.
    </div>
  )
}

export default ReferencePreview
